export default __webpack_public_path__ + "static/media/preview.c2a1193d.png";